<template>
    <div class="container">
        <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
        <div class="wrap" ref="viewport">
            <transition name="page-turn-fade" mode="out-in">
                <div class="meal-list-wrap" :key="currentPageKey">
                    <div class="meal-list" v-for="(section, sectionIndex) in currentPage.sections" :key="section.sectionKey + '-' + sectionIndex">
                        <div class="module-block">
                            <div class="module-body">
                                <div class="people-row">
                                    <div class="people-item">
                                        <div class="people-label">开餐人员数量</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.diningPeopleCount.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.diningPeopleCount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="people-item">
                                        <div class="people-label">学生人数</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.studentCount.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.studentCount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="people-item">
                                        <div class="people-label">补助标准</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.subsidyStandard.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.subsidyStandard.unit }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="metric-cards">
                                    <div class="metric-card">
                                        <div class="metric-label">采购金额</div>
                                        <div class="metric-value">
                                            <span class="metric-number">{{ amountMetrics.procurementAmount.text }}</span>
                                            <span class="metric-unit">{{ amountMetrics.procurementAmount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="metric-card">
                                        <div class="metric-label">补贴金额</div>
                                        <div class="metric-value">
                                            <span class="metric-number">{{ amountMetrics.subsidyAmount.text }}</span>
                                            <span class="metric-unit">{{ amountMetrics.subsidyAmount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="metric-card metric-card-stack">
                                        <div class="metric-pair">
                                            <div class="metric-pair-label">超支</div>
                                            <div class="metric-pair-value">
                                                <span class="metric-number">{{ amountMetrics.overspendAmount.text }}</span>
                                                <span class="metric-unit">{{ amountMetrics.overspendAmount.unit }}</span>
                                            </div>
                                        </div>
                                        <div class="metric-pair">
                                            <div class="metric-pair-label">结余</div>
                                            <div class="metric-pair-value">
                                                <span class="metric-number">{{ amountMetrics.balanceAmount.text }}</span>
                                                <span class="metric-unit">{{ amountMetrics.balanceAmount.unit }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="module-block module-gap module-block-no-border">
                            <div class="detail-table-panel">
                                <div class="detail-title-row">
                                    <div class="detail-title-left">食品采购明细（{{ detailDateText }}）</div>
                                    <div class="detail-title-right">统一供货商：{{ footerInfo.supplier || '--' }}</div>
                                </div>
                                <div class="detail-head" :ref="section.sectionKey + '-detailHead'">
                                    <div class="detail-col name">食品名称</div>
                                    <div class="detail-col qty">数量</div>
                                    <div class="detail-col price">单价(元)</div>
                                    <div class="detail-col amount">金额(元)</div>
                                </div>
                                <div class="detail-row" v-for="detail in section.detailRows" :key="detail.rowKey">
                                    <div class="detail-col name">{{ detail.name }}</div>
                                    <div class="detail-col qty">{{ detail.qtyText }}{{ detail.unit }}</div>
                                    <div class="detail-col price">{{ detail.priceText }}</div>
                                    <div class="detail-col amount">{{ detail.amountText }}</div>
                                </div>
                            </div>

                            <div class="footer-bar footer-bar-follow">
                                <span>采购员：{{ footerInfo.purchaser || '--' }}</span>
                                <span>验收员：{{ footerInfo.inspector || '--' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="measure-layer" aria-hidden="true">
                <div class="meal-list-wrap measure-wrap">
                    <div class="meal-list" v-for="(section, sectionIndex) in displaySections" :key="section.sectionKey + '-measure'">
                        <div class="module-block" :ref="'measureSummary-' + sectionIndex">
                            <div class="module-body">
                                <div class="people-row">
                                    <div class="people-item">
                                        <div class="people-label">开餐人员数量</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.diningPeopleCount.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.diningPeopleCount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="people-item">
                                        <div class="people-label">学生人数</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.studentCount.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.studentCount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="people-item">
                                        <div class="people-label">补助标准</div>
                                        <div class="people-value">
                                            <span class="people-number">{{ peopleMetrics.subsidyStandard.text }}</span>
                                            <span class="people-unit">{{ peopleMetrics.subsidyStandard.unit }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="metric-cards">
                                    <div class="metric-card">
                                        <div class="metric-label">采购金额</div>
                                        <div class="metric-value">
                                            <span class="metric-number">{{ amountMetrics.procurementAmount.text }}</span>
                                            <span class="metric-unit">{{ amountMetrics.procurementAmount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="metric-card">
                                        <div class="metric-label">补贴金额</div>
                                        <div class="metric-value">
                                            <span class="metric-number">{{ amountMetrics.subsidyAmount.text }}</span>
                                            <span class="metric-unit">{{ amountMetrics.subsidyAmount.unit }}</span>
                                        </div>
                                    </div>
                                    <div class="metric-card metric-card-stack">
                                        <div class="metric-pair">
                                            <div class="metric-pair-label">超支</div>
                                            <div class="metric-pair-value">
                                                <span class="metric-number">{{ amountMetrics.overspendAmount.text }}</span>
                                                <span class="metric-unit">{{ amountMetrics.overspendAmount.unit }}</span>
                                            </div>
                                        </div>
                                        <div class="metric-pair">
                                            <div class="metric-pair-label">结余</div>
                                            <div class="metric-pair-value">
                                                <span class="metric-number">{{ amountMetrics.balanceAmount.text }}</span>
                                                <span class="metric-unit">{{ amountMetrics.balanceAmount.unit }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="module-block module-gap module-block-no-border">
                            <div class="detail-table-panel">
                                <div class="detail-title-row">
                                    <div class="detail-title-left">食品采购明细（{{ detailDateText }}）</div>
                                    <div class="detail-title-right">统一供货商：{{ footerInfo.supplier || '--' }}</div>
                                </div>
                                <div class="detail-head" :ref="'measureDetailHead-' + sectionIndex">
                                    <div class="detail-col name">食品名称</div>
                                    <div class="detail-col qty">数量</div>
                                    <div class="detail-col price">单价(元)</div>
                                    <div class="detail-col amount">金额(元)</div>
                                </div>
                                <div class="detail-row" v-for="(detail, rowIndex) in section.detailRows" :key="detail.rowKey" :ref="'measureRow-' + sectionIndex + '-' + rowIndex">
                                    <div class="detail-col name">{{ detail.name }}</div>
                                    <div class="detail-col qty">{{ detail.qtyText }}{{ detail.unit }}</div>
                                    <div class="detail-col price">{{ detail.priceText }}</div>
                                    <div class="detail-col amount">{{ detail.amountText }}</div>
                                </div>
                            </div>

                            <div class="footer-bar footer-bar-follow">
                                <span>采购员：{{ footerInfo.purchaser || '--' }}</span>
                                <span>验收员：{{ footerInfo.inspector || '--' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PageTurnControl class="page-turn-control-position" :current="currentPageIndex + 1" :total="pages.length" theme="meal" @prev="goPrevPage" @next="goNextPage" />
        </div>
    </div>
</template>

<script>
import { paginateMeasuredSections } from '../assets/js/contentPaging';
import { canAutoTurnPage, getNextPageIndex, getPrevPageIndex } from '../assets/js/pageTurn';
import { buildNutritiousDiningProcurementSummaryRows, buildNutritiousDiningProcurementDetailRows } from '../assets/js/nutritiousDiningProcurementSections';
import { formatTime } from '../assets/js/common';
import PageTurnControl from './PageTurnControl.vue';
import schoolAndDate from './schoolAndDate.vue';

export default {
    props: {
        deptId: {
            type: String,
            default: '',
        },
        outletsId: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
        schoolName: {
            type: String,
            default: '',
        },
    },
    components: { PageTurnControl, schoolAndDate },
    data() {
        return {
            procurementDetail: {},
            pages: [],
            currentPageIndex: 0,
            pageTimer: null,
        };
    },
    computed: {
        procurementInfo() {
            var procurement = this.procurementDetail && this.procurementDetail.procurement;
            if (!procurement || Array.isArray(procurement) || typeof procurement !== 'object') {
                return {};
            }
            return procurement;
        },
        summaryRows() {
            return buildNutritiousDiningProcurementSummaryRows(this.procurementDetail).filter(function (row) {
                return row && row.label !== '采购日期' && row.label !== '联系方式';
            });
        },
        detailRows() {
            return buildNutritiousDiningProcurementDetailRows(this.procurementDetail);
        },
        peopleMetrics() {
            return {
                diningPeopleCount: {
                    text: this.toMetricText(this.procurementInfo.diningPeopleCount),
                    unit: '人',
                },
                studentCount: {
                    text: this.toMetricText(this.procurementInfo.studentCount),
                    unit: '人',
                },
                subsidyStandard: {
                    text: this.toMetricText(this.procurementInfo.subsidyStandard),
                    unit: '元/人',
                },
            };
        },
        amountMetrics() {
            return {
                procurementAmount: {
                    text: this.toMetricText(this.procurementInfo.procurementAmount),
                    unit: '元',
                },
                subsidyAmount: {
                    text: this.toMetricText(this.procurementInfo.subsidyAmount),
                    unit: '元',
                },
                overspendAmount: {
                    text: this.toMetricText(this.procurementInfo.overspendAmount),
                    unit: '元',
                },
                balanceAmount: {
                    text: this.toMetricText(this.procurementInfo.balanceAmount),
                    unit: '元',
                },
            };
        },
        detailDateText() {
            var raw = this.procurementInfo.procurementDate;
            if (!raw) {
                return '--';
            }
            var normalized = String(raw).trim();
            return normalized || '--';
        },
        footerInfo() {
            return {
                purchaser: String(this.procurementInfo.purchaser || '').trim(),
                inspector: String(this.procurementInfo.inspector || '').trim(),
                supplier: String(this.procurementInfo.supplier || '').trim(),
            };
        },
        displaySections() {
            var summaryRows = this.summaryRows.map(function (row, index) {
                return {
                    rowKey: 'summary-row-' + index,
                    label: row && row.label ? row.label : '',
                    value: row && row.value ? row.value : '',
                };
            });
            var detailRows = this.detailRows.map(function (row, index) {
                return {
                    rowKey: 'detail-row-' + index,
                    name: row && row.name ? row.name : '',
                    unit: row && row.unit ? row.unit : '',
                    qtyText: row && row.qtyText ? row.qtyText : '',
                    priceText: row && row.priceText ? row.priceText : '',
                    amountText: row && row.amountText ? row.amountText : '',
                };
            });

            return [
                {
                    sectionKey: 'procurement',
                    sectionHeader: { startDate: '', endDate: '' },
                    summaryRows: summaryRows,
                    detailRows: detailRows,
                },
            ];
        },
        currentPage() {
            return this.pages[this.currentPageIndex] || { sections: [] };
        },
        currentPageKey() {
            return 'page-' + this.currentPageIndex;
        },
        autoplayDuration() {
            var query = this.$route && this.$route.query ? this.$route.query : {};
            var autoplay = query && query.autoplay ? parseInt(query.autoplay, 10) : 0;

            if (isNaN(autoplay) || autoplay <= 0) {
                return 0;
            }

            return autoplay;
        },
    },
    watch: {
        procurementDetail: {
            deep: true,
            handler: function () {
                this.rebuildPages();
            },
        },
        '$route.query.autoplay': function () {
            this.startPageTimer();
        },
    },
    mounted() {
        this.fetchProcurementDetail();
        window.addEventListener('resize', this.rebuildPages);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.rebuildPages);
        this.stopPageTimer();
    },
    methods: {
        toMetricText(value) {
            var normalized = Number(value);
            if (!Number.isFinite(normalized)) {
                return '--';
            }
            return String(value);
        },
        fetchProcurementDetail() {
            var query = this.$route && this.$route.query ? this.$route.query : {};
            var procurementDate = query && query.procurementDate ? String(query.procurementDate) : '';

            // backward compatible fallback
            if (!procurementDate) {
                procurementDate = query && query.date ? String(query.date) : '';
            }

            if (!procurementDate) {
                procurementDate = formatTime(new Date(), 'yyyy-MM-dd');
            }

            var param = {
                canteenId: this.deptId,
                procurementDate: procurementDate,
            };

            this.$get(this.$api.getNutritiousDiningProcurementDateDetail, param).then((res) => {
                this.procurementDetail = res && res.data && typeof res.data === 'object' ? res.data : {};
            });
        },
        stopPageTimer() {
            if (this.pageTimer) {
                clearInterval(this.pageTimer);
                this.pageTimer = null;
            }
        },
        startPageTimer() {
            var vm = this;
            this.stopPageTimer();
            if (!canAutoTurnPage(this.pages.length, this.autoplayDuration)) {
                return;
            }
            this.pageTimer = setInterval(function () {
                vm.currentPageIndex = getNextPageIndex(vm.currentPageIndex, vm.pages.length);
            }, this.autoplayDuration);
        },
        restartPageTimer() {
            this.stopPageTimer();
            this.startPageTimer();
        },
        goPrevPage() {
            this.currentPageIndex = getPrevPageIndex(this.currentPageIndex, this.pages.length);
            this.restartPageTimer();
        },
        goNextPage() {
            this.currentPageIndex = getNextPageIndex(this.currentPageIndex, this.pages.length);
            this.restartPageTimer();
        },
        getRefElement(refName) {
            var refValue = this.$refs[refName];
            return Array.isArray(refValue) ? refValue[0] : refValue;
        },
        getMeasuredSection(section, sectionIndex) {
            var summaryEl = this.getRefElement('measureSummary-' + sectionIndex);
            var detailHeadEl = this.getRefElement('measureDetailHead-' + sectionIndex);
            var rows = section.detailRows.map(function (row, rowIndex) {
                var rowEl = this.getRefElement('measureRow-' + sectionIndex + '-' + rowIndex);
                return {
                    rowKey: row.rowKey,
                    measuredHeight: rowEl ? rowEl.offsetHeight : 0,
                    payload: row,
                };
            }, this);

            return {
                sectionKey: section.sectionKey,
                sectionHeader: section.sectionHeader,
                headerHeight: (summaryEl ? summaryEl.offsetHeight : 0) + (detailHeadEl ? detailHeadEl.offsetHeight : 0) + 24,
                rows: rows,
            };
        },
        getMeasureWrapInset() {
            var measureWrap = this.$el ? this.$el.querySelector('.measure-wrap') : null;
            var styles;
            if (!measureWrap) {
                return 0;
            }
            styles = window.getComputedStyle(measureWrap);
            return (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
        },
        getSectionGap() {
            var firstSection = this.$el ? this.$el.querySelector('.measure-wrap .meal-list') : null;
            var styles;
            if (!firstSection) {
                return 0;
            }
            styles = window.getComputedStyle(firstSection);
            return parseFloat(styles.marginBottom) || 0;
        },
        rebuildPages() {
            this.$nextTick(function () {
                var viewport = this.$refs.viewport;
                var pageInset = this.getMeasureWrapInset();
                var sectionGap = this.getSectionGap();
                var measuredSections = this.displaySections.map(function (section, index) {
                    return this.getMeasuredSection(section, index);
                }, this);

                this.pages = paginateMeasuredSections({
                    maxPageHeight: viewport ? viewport.clientHeight : 0,
                    pageInset: pageInset,
                    sectionGap: sectionGap,
                    sections: measuredSections,
                }).map(function (page) {
                    return {
                        pageIndex: page.pageIndex,
                        sections: page.sections.map(function (section) {
                            return {
                                sectionKey: section.sectionKey,
                                sectionHeader: section.sectionHeader,
                                continued: section.continued,
                                summaryRows: [],
                                detailRows: section.rows.map(function (row) {
                                    return row.payload;
                                }),
                            };
                        }),
                    };
                });

                // rebuild pages should preserve summary on every page
                this.pages = this.pages.map(function (page) {
                    var summaryRows = this.displaySections[0] ? this.displaySections[0].summaryRows : [];
                    return {
                        pageIndex: page.pageIndex,
                        sections: page.sections.map(function (section) {
                            return {
                                sectionKey: section.sectionKey,
                                sectionHeader: section.sectionHeader,
                                continued: section.continued,
                                summaryRows: summaryRows,
                                detailRows: section.detailRows,
                            };
                        }, this),
                    };
                }, this);

                if (this.currentPageIndex >= this.pages.length) {
                    this.currentPageIndex = 0;
                }

                this.startPageTimer();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
$fontColor: #0A7B23;
$borderColor: #59C06F;

.wrap {
    position: relative;
    height: vh(785);
    background: #b2f5c2;
    border-radius: 3px;
    overflow: hidden;
    font-weight: bold;
}

.meal-list-wrap {
    padding: vh(12) vh(18) vh(58);
}

.meal-list {
    margin-bottom: vh(10);
}

.module-block {
    border: 1px solid $borderColor;
    color: $fontColor;
    background: transparent;
    border-radius: vh(10);
    overflow: hidden;
}

/* 明细区域：外框交由 detail-table-panel 提供，避免双外框 */
.module-block-no-border {
    border: 0;
}

.module-gap {
    margin-top: vh(8);
}

.module-title {
    background: #8EDE9F;
    padding: vh(6) vh(8);
    font-weight: 600;
}

.module-body {
    /* 避免与 module-block 自身边框叠加形成双边框 */
    border-top: 0;
    padding: vh(8) vh(10);
}

.people-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: vh(8);
    margin-bottom: vh(8);
}

.people-item {
    border: 1px solid $borderColor;
    border-radius: vh(8);
    padding: vh(6) vh(8);
    background: rgba(142, 222, 159, 0.18);
}

.people-label {
    font-size: vh(14);
    opacity: 0.95;
}

.people-value {
    margin-top: vh(4);
    font-size: vh(18);
    line-height: 1.1;
}

.people-number,
.people-unit {
    font-size: inherit;
}

.people-unit {
    margin-left: vh(6);
}

.metric-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: vh(8);
}

.metric-card {
    border: 1px solid $borderColor;
    border-radius: vh(8);
    padding: vh(6) vh(8);
    background: rgba(142, 222, 159, 0.12);
}

.metric-label {
    font-size: vh(14);
    opacity: 0.95;
}

.metric-value {
    margin-top: vh(4);
    font-size: vh(18);
    line-height: 1.1;
}

.metric-number,
.metric-unit {
    font-size: inherit;
}

.metric-unit {
    margin-left: vh(6);
}

.metric-card-stack {
    display: flex;
    flex-direction: column;
    gap: vh(8);
}

.metric-pair {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.metric-pair-label {
    font-size: vh(14);
}

.metric-pair-value {
    font-size: vh(18);
    line-height: 1.1;
}

.detail-table-panel {
    border: 1px solid $borderColor;
    border-radius: vh(8);
    overflow: hidden;
    background: #B2F5C2;
}

.detail-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: vh(8);
    background: #8EDE9F;
    border-bottom: 1px solid $borderColor;
    padding: vh(6) vh(8);
    font-size: vh(13);
    font-weight: 600;
}

.footer-bar {
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: vh(8);
    /* 位于浅绿底上，使用深色半透明底保证可读性 */
    background: rgba(0, 4, 143, 0.55);
    color: #EAF2FF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: vh(6);
    font-size: vh(12);
    padding: vh(6) vh(8);
}

/* 页脚：跟随表格，离表格 10px，且为全圆角矩形 */
.footer-bar-follow {
    margin-top: 10px;
    border-radius: vh(8);
}

.detail-title-left,
.detail-title-right {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.detail-title-right {
    text-align: right;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-top: 1px solid $borderColor;
}

.summary-cell {
    padding: vh(6) vh(8);
    border-right: 1px solid $borderColor;
    border-bottom: 1px solid $borderColor;
    box-sizing: border-box;

    &:nth-of-type(4n) {
        border-right: 0;
    }
}

.summary-label {
    font-size: vh(14);
    color: $fontColor;
    opacity: 0.95;
}

.summary-value {
    font-size: vh(16);
    color: $fontColor;
    word-break: break-all;
    line-height: 1.2;
}

.module-row {
    display: flex;
    border-top: 1px solid $borderColor;
}

.module-label {
    width: 35%;
    padding: vh(6) vh(8);
    border-right: 1px solid $borderColor;
    box-sizing: border-box;
}

.module-value {
    width: 65%;
    padding: vh(6) vh(8);
    box-sizing: border-box;
    word-break: break-all;
}

.detail-head,
.detail-row {
    display: flex;
    border-top: 1px solid $borderColor;
}

.detail-head {
    background: #8EDE9F;
    font-weight: 600;
}

.detail-col {
    padding: vh(6) vh(6);
    box-sizing: border-box;
    word-break: break-all;
    border-right: 1px solid $borderColor;
    text-align: center;
}

.detail-col:last-child {
    border-right: 0;
}

.detail-col.name { width: 32%; }
.detail-col.qty { width: 22%; text-align: center; }
.detail-col.price { width: 23%; text-align: center; }
.detail-col.amount { width: 23%; text-align: center; }

/* (moved) footer-bar is positioned absolute above */

.measure-layer {
    position: absolute;
    left: -9999px;
    top: 0;
    width: 100%;
    height: auto;
    opacity: 0;
    pointer-events: none;
}

.page-turn-control-position {
    position: absolute;
    left: 50%;
    bottom: vh(8);
    z-index: 8;
    transform: translateX(-50%);
}

.page-turn-fade-enter-active,
.page-turn-fade-leave-active {
    transition: opacity 0.3s ease;
}

.page-turn-fade-enter,
.page-turn-fade-leave-to {
    opacity: 0;
}
</style>
